"use client";

import type {
	NavigateOptions,
	PrefetchOptions,
} from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useRouter as useNavigation } from "next/navigation";
import NProgress from "nprogress";
import { useLocale } from "~/app/[lang]/providers/LocaleContext";

export function useRouter() {
	const router = useNavigation();
	const { lang, domain } = useLocale();

	function applyPrefix(href: string) {
		const prefix = lang !== domain.defaultLocale || domain.alwaysPrefix ? `/${lang}` : "";

		return href.includes(prefix) ? href : `${prefix}${href}`;
	}

	return {
		...router,
		push: (href: string, options?: NavigateOptions) => {
			if (href.includes("http")) {
				return router.push(href, options);
			}
			const url = applyPrefix(href);

			if (window.location.pathname !== url) {
				NProgress.start();
			}

			return router.push(url, options);
		},
		replace: (href: string, options?: NavigateOptions) => {
			if (href.includes("http")) {
				return router.replace(href, options);
			}

			return router.replace(applyPrefix(href), options);
		},
		prefetch: (href: string, options?: PrefetchOptions) => {
			if (href.includes("http")) {
				return router.prefetch(href, options);
			}

			return router.prefetch(applyPrefix(href), options);
		},
		tab: (href: string) => {
			window.open(applyPrefix(href), "_blank", "noopener,noreferrer")?.focus();
		},
	} as const;
}
